import { t } from 'i18n';
import { useState } from 'react';
import { useCart } from 'contexts';
import { ComboItem, AddToCartReq } from 'types';
import { ComboDetailPayload } from '@teko/discovery';

const getTextWarning = (e: any) => {
  const code = e?.code?.toString();
  switch (code) {
    case '400113': // CONFLICT_PART_ORDER_PROMOTION
      return t('sites.shop-front.hooks.useCartCombo.0');
    case '400114': // CONFLICT_COMBO_PROMOTION
      return t('sites.shop-front.hooks.useCartCombo.1');
    case '400116': // CONFLICT_COMBO_AND_PART_ORDER_PROMOTION
      return t('sites.shop-front.hooks.useCartCombo.2');
    default:
      return null;
  }
};
export const useCartCombo = (mainSku: string) => {
  const cart = useCart();
  const [visiblePopupWarning, setVisiblePopupWarning] = useState(false);
  const [textWarning, setTextWarning] = useState<string>();
  const onClosePopupWarning = () => {
    setVisiblePopupWarning(false);
    setTextWarning(undefined);
  };

  const onAddComboToCart = !mainSku
    ? null
    : async (
        type: ComboItem['type'],
        payload: ComboDetailPayload,
        override = true,
      ) => {
        if (type === 'autogen') {
          await cart.onAddMultiToCart(payload.comboLineItems as AddToCartReq[]);
        } else {
          try {
            const mainPayload = {
              override,
              groups: [
                {
                  quantity: 1,
                  promotionId: payload.promotionId,
                  products: payload.comboLineItems.map((el, index) => ({
                    sku: el.sku,
                    quantity: el.quantity,
                    isPrimary: index === 0,
                  })),
                },
              ],
            } as AddToCartReq;
            await cart.onAddToCart(mainPayload);
          } catch (e: any) {
            if (!override) {
              const warning = getTextWarning(e);
              if (warning) {
                setTextWarning(warning);
                setVisiblePopupWarning(true);
              }
            }
            return Promise.reject(e);
          }
        }
      };
  return {
    cart,
    onAddComboToCart,
    visiblePopupWarning,
    onClosePopupWarning,
    textWarning,
  };
};
